import { createReducer, Action, on } from '@ngrx/store';

import { MenuActions } from './menu.actions';
import { MenuState } from './menu.state';
import { measureReducer } from '../../features/shared/utils/runtime-reducer-stats';

export const initialState: MenuState = {
  url: '',
  visibilityQueue: [],
  collapsedMenuItems: {},
};

const featureReducer = measureReducer(
  createReducer(
    initialState,
    on(
      MenuActions.UpdateVisibilityQueue,
      (state, action): MenuState => ({ ...state, visibilityQueue: action.visibilityQueue })
    ),
    on(
      MenuActions.Navigation,
      (state, action): MenuState => ({ ...state, url: action.url, visibilityQueue: [] })
    ),
    on(
      MenuActions.CollapseMenu,
      (state, action): MenuState => ({
        ...state,
        collapsedMenuItems: {
          ...state.collapsedMenuItems,
          [action.shortCode]: !state.collapsedMenuItems[action.shortCode],
        },
      })
    ),
    on(
      MenuActions.SelectMenu,
      (state, action): MenuState => ({ ...state, selectedMenu: action.menu })
    )
  )
);

export function reducer(state: MenuState | undefined, action: Action) {
  return featureReducer(state, action);
}
